import { Link, useNavigate } from "react-router-dom";

function getPrimaryImage(product) {
  const image = product.image_url;

  if (!image) {
    return "/placeholder-product.jpg";
  }

  if (image.startsWith("http://") || image.startsWith("https://")) {
    return image;
  }

  return `https://kinewsstudiolimited.co.uk/${image.replace(/^\/+/, "")}`;
}

export default function HomeShopPreviewSection({
  products = [],
  loading = false,
  error = "",
}) {
  const navigate = useNavigate();

  const displayedProducts = Array.isArray(products)
    ? products.slice(0, 6)
    : [];

  return (
    <section className="bg-white">
      <div className="mx-auto max-w-7xl px-6 py-16 md:py-20">
        <div className="text-center">
          <p className="text-sm uppercase tracking-[0.3em] text-pink-500/80">
            Shop
          </p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-black md:text-4xl">
            Explore our collection
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-black/65 md:text-base">
            Discover custom frames, prints, and beautifully crafted pieces designed to preserve your most meaningful moments.
          </p>
        </div>

        {loading ? (
          <div className="mt-10 rounded-3xl border border-black/10 bg-black/[0.03] p-8 text-center">
            Loading products...
          </div>
        ) : error ? (
          <div className="mt-10 rounded-3xl border border-red-200 bg-red-50 p-8 text-center text-red-600">
            {error}
          </div>
        ) : displayedProducts.length === 0 ? (
          <div className="mt-10 rounded-3xl border border-black/10 bg-black/[0.03] p-8 text-center">
            No products available.
          </div>
        ) : (
          <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {displayedProducts.map((product) => {
              const image = getPrimaryImage(product);

              return (
                <div
                  key={product.id}
                  onClick={() => navigate(`/shop/${product.id}`)}
                  className="group cursor-pointer overflow-hidden rounded-3xl border border-black/10 bg-white transition duration-200 hover:-translate-y-1 hover:border-black/30 hover:shadow-lg"
                >
                  <div className="relative aspect-[4/3] overflow-hidden bg-black/[0.04]">
                    <img
                      src={image}
                      alt={product.name}
                      className="h-full w-full object-cover transition duration-300 group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>

                  <div className="p-4">
                    <h3 className="text-sm font-semibold text-slate-900">
                      {product.name}
                    </h3>

                    <p className="mt-1 text-xs text-slate-500">
                      From:{" "}
                      <span className="text-sm font-medium text-slate-900">
                        {product.base_price !== null
                          ? `£${Number(product.base_price).toFixed(2)}`
                          : "£0.00"}
                      </span>
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="mt-12 text-center">
          <Link
            to="/shop"
            className="inline-flex rounded-full border border-pink-500/30 px-6 py-3 text-sm font-medium text-pink-500 transition hover:bg-pink-500/10"
          >
            Visit Shop
          </Link>
        </div>
      </div>
    </section>
  );
}